import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { ImportSupplierFormikValues } from '../../models/import-supplier-formik-values';
import { ImportSupplierRequest } from '../../models/import-supplier';
import { ImportSuppliersApi } from '../../api/import-suppliers.api';

const api = new ImportSuppliersApi(API_BASE_URL);

export interface GetImportSuppliersParams {
    searchParams: URLSearchParams;
}

export interface AddOrUpdateImportSuppliersParams {
    importSupplier: ImportSupplierFormikValues;
}

export const fetchImportSuppliers = createAsyncThunk(
    'import-suppliers/fetchImportSuppliers',
    async (params: GetImportSuppliersParams, thunkAPI) => {
        const response = await api.getImportSuppliers(params.searchParams);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }

        return response.result;
    }
);

export const addOrUpdateImportSuppliers = createAsyncThunk(
    'import-suppliers/addOrUpdateImportSuppliers',
    async (params: AddOrUpdateImportSuppliersParams, thunkAPI) => {
        const tempSupplier: ImportSupplierRequest = {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            supplierAccountId: params.importSupplier.supplier!.id,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            importIntervalType: params.importSupplier.importIntervalType!,
            time: params.importSupplier.time ?? undefined, // `${hours}:${minutes}` :
            weekday: params.importSupplier.weekday,
            dayOfMonth: params.importSupplier.dayOfMonth,
            month: params.importSupplier.month,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            importReceptionType: params.importSupplier.importReceptionType!,
            internalNote: params.importSupplier.internalNote ?? undefined,
        };

        const response = params.importSupplier.id
            ? await api.updateImportSupplier(params.importSupplier.id, tempSupplier)
            : await api.addImportSupplier(tempSupplier);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }

        return { id: params.importSupplier.id, result: response.result };
    }
);

export const deleteImportSupplier = createAsyncThunk(
    'import-suppliers/deleteImportSupplier',
    async (params: { importSupplierId: number }, thunkAPI) => {
        const response = await api.deleteImportSupplier(params.importSupplierId);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }

        return params.importSupplierId;
    }
);
